import React, { useLayoutEffect, useRef } from 'react'
import { usePan, useZoom } from '@sketch-hq/sketch-web-renderer'

export interface CameraSnapshot {
  pan: { x: number; y: number } | null
  zoom: number | null
}

export function useCameraRef() {
  return useRef<CameraSnapshot>({ pan: null, zoom: null })
}

/**
 * Keeps `cameraRef` on the camera without re-rendering whoever owns the ref.
 *
 * The renderer hands pan and zoom out through context, so reading them
 * re-renders the reader on every frame of a drag - and with it everything the
 * reader renders. A component that only needs the camera inside a handler
 * renders this instead, and only this re-renders.
 */
export function CameraRefSync({
  cameraRef,
}: {
  cameraRef: React.RefObject<CameraSnapshot>
}) {
  const pan = usePan()
  const zoom = useZoom()

  useLayoutEffect(() => {
    cameraRef.current = { pan, zoom }
  }, [cameraRef, pan, zoom])

  return null
}
